import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
// import ZoomMtgEmbedded from '@zoomus/websdk/embedded';
import { PagesService } from 'src/app/core/_services/pages/pages.service';


@Component({
  selector: 'app-secure',
  templateUrl: './secure.component.html',
  styleUrls: ['./secure.component.scss']
})
export class SecureComponent implements OnInit {
  constructor() {
   }

  ngOnInit(): void {
  }
}
